module.exports = __webpack_public_path__ + "img/icon_open.234bcf4c.svg";